<template>
  <div>
    <keep-alive>
      <div :is="currentComponent" :swap-component="swapComponent" :form="form" :profiles="profiles" :progress="progress" @fill-genders="fillGenders" @reset-form="resetForm" @update:progress="progress = $event"></div>
    </keep-alive>
  </div>
</template>
<script>
import WelcomeCard from './WelcomeCard.vue';
import RegisterEmailCard from './RegisterEmailCard.vue';
import RegisterPhoneCard from './RegisterPhoneCard.vue';
import VerificationEmailCard from './VerificationEmailCard.vue';
import ChangeEmailCard from './ChangeEmailCard.vue';
import VerificationPhoneCard from './VerificationPhoneCard.vue';
import LoginCard from './LoginCard.vue';
import NameCard from './NameCard.vue';
// import GenderCard from './GenderCard.vue';
import BirthdayCard from './BirthdayCard.vue';
import LocationCard from './LocationCard.vue';
import RegistrationSuccessCard from './RegistrationSuccessCard';
import ResetPasswordCard from './ResetPasswordCard';
import ResetPasswordEmailCard from './ResetPasswordEmailCard';
import ResetPasswordPhoneCodeCard from './ResetPasswordPhoneCodeCard';
import ResetPasswordPhoneCard from './ResetPasswordPhoneCard';

export default {
  name: 'AuthCard',
  props: {
    cardComponent: {
      type: String,
      default: 'auth-welcome-card',
    },
    email: {
      type: String,
      default: null,
    },
    cid: {
      type: String,
      default: null,
    },
    profiles: {
      type: Array
    }
  },
  data: () => ({
    currentComponent: '',
    form: {
      name: null,
      gender: null,
      preferred_gender: [],
      birth_date: null,
      location_id: null,
      phone: null,
      //    token: '',
      email: null,
    },
    progress: 0,
  }),
  components: {
    'auth-welcome-card': WelcomeCard,
    'auth-register-email-card': RegisterEmailCard,
    'auth-register-phone-card': RegisterPhoneCard,
    'auth-verification-phone-card': VerificationPhoneCard,
    'auth-verification-email-card': VerificationEmailCard,
    'auth-change-email-card': ChangeEmailCard,
    'auth-login-card': LoginCard,
    'auth-name-card': NameCard,
    // 'auth-gender-card': GenderCard,
    'auth-birthday-card': BirthdayCard,
    'auth-location-card': LocationCard,
    'auth-registration-success-card': RegistrationSuccessCard,
    'auth-reset-password-card': ResetPasswordCard,
    'auth-reset-password-email-card': ResetPasswordEmailCard,
    'auth-reset-password-phone-code-card': ResetPasswordPhoneCodeCard,
    'auth-reset-password-phone-card': ResetPasswordPhoneCard,
  },
  computed: {
    isFillDataCard: function () {
      const fillDataCards = [
        'auth-name-card',
        // 'auth-gender-card',
        'auth-birthday-card',
        'auth-location-card'
      ];
      return fillDataCards.includes(this.currentComponent);
    }
  },
  watch: {
    currentComponent: function (value) {
      this.$store.commit('auth/setCurrentComponent', value);

      let homepage = document.getElementById('homepage');
      let registrationSteps = ['auth-name-card', 'auth-verification-phone-card', 'auth-birthday-card',
        'auth-verification-email-card', 'auth-location-card', 'auth-registration-success-card'];

      if (homepage && value === 'auth-welcome-card') {
        homepage.classList.add('vue-welcome-card', 'choose-gender');
      } else if (homepage && value === 'auth-register-email-card') {
        homepage.classList.add('vue-welcome-card');
        homepage.classList.remove('choose-gender');
      } else if (homepage && value === 'auth-login-card') {
        homepage.classList.add('vue-welcome-card');
        homepage.classList.remove('choose-gender');
      } else if (homepage) {
        homepage.classList.remove('vue-welcome-card', 'choose-gender');
      }

      if (homepage && registrationSteps.includes(value))
        homepage.classList.add('register-step');
      else
        homepage.classList.remove('register-step');
    }
  },
  methods: {
    fillGenders(data) {
      this.form.gender = data.gender;
      this.form.preferred_gender = data.preferred_gender;
    },
    resetForm() {
      this.form.name = null;
      this.form.gender = null;
      this.form.preferred_gender = [];
      this.form.birth_date = null;
      this.form.location_id = null;
      this.form.phone = null;
      this.form.email = null;
    },
    swapComponent: function (component) {
      this.currentComponent = component;
    },
    initialComponent() {
      const vm = this;
      axios.get(zRoute('ajax.auth.users.show'))
        .then(function (response) {
          if (response.status !== 204) {
            vm.form = response.data.data;

            switch (vm.form.step) {
              case 'email':
                vm.currentComponent = 'auth-verification-email-card';
                break;
              case 'phone':
                vm.currentComponent = 'auth-verification-phone-card';
                break;
              case 'name':
                vm.currentComponent = 'auth-name-card';
                break;
              // case 'gender':
              //     vm.currentComponent = 'auth-gender-card';
              //     break;
              case 'birthday':
                vm.currentComponent = 'auth-birthday-card';
                break;
              case 'location':
                vm.currentComponent = 'auth-location-card';
                break;
              default:
                vm.currentComponent = vm.form.filled ? vm.cardComponent : 'auth-name-card';
            }
          } else {
            vm.currentComponent = vm.cardComponent;
          }
        }, function (error) {
          vm.currentComponent = vm.cardComponent;
        });
    },
  },
  created() {
    if (this.email !== null && this.email !== '') {
      this.form.email = this.email;
      this.currentComponent = 'auth-register-email-card';
    } else {
      this.initialComponent();
    }

    if (this.cid) {
      window.localStorage.setItem('campaign_cid', this.cid);
    }
  }
};
</script>
<style scoped>
</style>
